import General from "./General.container.view";

export default General;
